export enum REWARDS_TABS {
    CHALLENGES = 'challenges',
    ACHIEVEMENTS = 'achievements',
}

export enum STATS_TABS {
    STATS = 'stats',
    GAME_HISTORY = 'games history',
}
